import { PageLayout } from '@/shared/layout/PageLayout';

export function AdjustmentsPage() {
  return (
    <PageLayout title="Module adjustments" description="Quản lý adjustments">
      <div className="p-4 bg-white rounded-md shadow-sm border border-slate-200">
        <p className="text-slate-500">Not implemented yet</p>
      </div>
    </PageLayout>
  );
}
